<template>
  <v-list two-line>
    <template v-for="(e, index) in events">
      <v-list-item :key="e.id" :to="{ name: 'event', params: { id: e.id } }">
        <v-list-item-avatar tile>
          <v-avatar
            size="54"
            rounded
            color="primary"
            class="v-avatar-light-bg primary--text mt-1"
          >
            <div>
              <p class="font-weight-small mb-0 text-xs">
                {{ getShortMonthName(e.time) }}
              </p>
              <p class="text-sm primary--text font-weight-bold mb-0">
                {{ getDayOfMonth(e.time) }}
              </p>
            </div>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="mb-1 text-lg">
            {{ e.title }}
          </v-list-item-title>

          <v-list-item-subtitle> {{ getEventTime(e) }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text>
            <v-chip small>
              {{ e.group_name }}
            </v-chip>
          </v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
      <v-divider
        v-if="index < events.length - 1"
        :key="`divider-${e.id}`"
      ></v-divider>
    </template>
  </v-list>
</template>

<script>
import {
  getDateTime,
  getDayOfMonth,
  getShortDate,
  getShortMonthName,
  getTime,
} from "@/@core/utils/datetime_helpers";
import moment from "moment";

export default {
  props: ["events"],
  setup() {
    const getEventTime = (event) => {
      if (event.end_time) {
        if (moment(event.time).isSame(event.end_time, "day")) {
          return (
            getShortDate(event.time) +
            " klo " +
            getTime(event.time) +
            "-" +
            getTime(event.end_time)
          );
        } else {
          return (
            getShortDate(event.time) +
            " " +
            getTime(event.time) +
            " - " +
            getShortDate(event.end_time) +
            " " +
            getTime(event.end_time)
          );
        }
      }

      return getDateTime(event.time);
    };

    return {
      getEventTime,
      getDayOfMonth,
      getShortMonthName,
    };
  },
};
</script>

<style>
</style>